import { createContext, useContext, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types'

// Create a context for the resize information
const ResizeContext = createContext({ width: 0, height: 0 });

// Custom hook for child components to use the context
export const useResizeContext = () => useContext(ResizeContext);

export const ResizeAwareDiv = ({ children, ...props }) => {
    const paneRef = useRef(null);
    const resizeDebounce = useRef();
    const [size, setSize] = useState({ width: undefined, height: undefined });

    useEffect(() => {
        const handleResize = (entries) => {
            if (entries[0]) {
                const { width, height } = entries[0].contentRect;
                if (resizeDebounce.current) {
                    clearTimeout(resizeDebounce.current);
                }
                resizeDebounce.current = setTimeout(() => {
                    setSize({ width, height });
                    resizeDebounce.current = null;
                }, 200);
            }
        };

        const observer = new ResizeObserver(handleResize);
        if (paneRef.current) {
            setSize({ width: paneRef.current.offsetWidth, height: paneRef.current.offsetHeight })
            observer.observe(paneRef.current);
        }

        return () => observer.disconnect();
    }, []);

    return (
        <ResizeContext.Provider value={size}>
            <div className="w-100 h-100 p-0" ref={paneRef} {...props}>
                {children}
            </div>
        </ResizeContext.Provider>
    );
}

ResizeAwareDiv.propTypes = {
    children: PropTypes.node,
}